import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import styles from './style.css';

class FilteredReport extends React.Component {
  render() {
    const { report, reportDetail, openRightColumn } = this.props;

    let dateStr = moment(report.updatedAt).format('DD/MM/YYYY');
    if (!openRightColumn) {
      dateStr = moment(report.updatedAt).format('DD MMMM YYYY');
    }
    const duration = moment(report.updatedAt).diff(
      moment(report.createdAt),
      'minutes'
    );

    let activeStyle = styles['rounded-cancelled'];
    if (report.status === 'COMPLETE') {
      activeStyle = styles['rounded-completed'];
    }
    const isRowSelected = reportDetail && report.id === reportDetail.id;
    if (isRowSelected) {
      if (report.status === 'COMPLETE') {
        activeStyle = styles['rounded-white-completed'];
      } else {
        activeStyle = styles['rounded-white-cancelled'];
      }
    }
    return (
      <tr
        className={`${isRowSelected ? styles.selected : ''} ${styles.row}`}
        onClick={this._onClickRow}
      >
        <td className={styles.name}>{dateStr}</td>
        <td className={styles.name}>{report.receiptNo}</td>
        <td className={styles.name}>{report.serveByName}</td>
        <td className={styles.name}>{report.pax}</td>
        <td className={styles.name}>{duration} Min</td>
        <td className={styles.name}>
          <span className={`${activeStyle}`}>
            {report.status === 'COMPLETE' ? 'Completed' : 'Cancelled'}
          </span>
        </td>
      </tr>
    );
  }

  _onClickRow = () => {
    const { onClickRow, report } = this.props;
    onClickRow(report);
  };
}

function mapStateToProps(state) {
  const { openRightColumn } = state.tableManagement.report;
  return {
    openRightColumn,
  };
}

export default connect(mapStateToProps)(FilteredReport);
